import {
  Centred,
  Contents,
} from '../../styles/mixins'

const styles = theme => ({
  centred: {
    ...Centred(theme),
  },
  contents: {
    ...Contents(theme),
  },

  errorPage: {
    position: 'absolute',
    margin: 0,
    width: '100%',
    height: '100vh',
  },

  unsupported: {
    height: '100%',
    '& h1': {
      display: 'block',
      fontWeight: 800,
      color: 'rgba(255,255,255,1)',
    },
    '& h3': {
      display: 'block',
      fontWeight: 400,
      color: 'rgba(255,255,255,1)',
    },
    '& p': {
      marginTop: theme.spacing.unit * 3,
      color: 'rgba(255,255,255,1)',
    }
  },

})

export default styles





// WEBPACK FOOTER //
// ./src/components/unsupported/styles.js